import moment from 'moment-timezone';
import celsiusToFahrenheit from '../util/celsius-to-fahrenheit'
import getHeatIndex from '../util/get-heat-index'
import fahrenheitToCelsius from '../util/fahrenheit-to-celsius'
import roundTo from 'round-to'
import isUndefined from 'lodash.isundefined'

const downloadReadings = (dateRange, sensor, readings) => {

  return new Promise((resolve, reject) => {

    let csvContent = "";

    const details = [
      {
        label: 'Sensor',
        value: sensor.sensor_name + ` (ID: ${sensor.sensor_id})`,
      },
      {
        label: 'Created',
        value: moment().format('YYYY-MM-DD HH:mm:ss z'),
      },
      {
        label: 'Start',
        value: window.getUserTimezoneDate(readings.start).format('YYYY-MM-DD HH:mm:ss z'),
      },
      {
        label: 'End',
        value: window.getUserTimezoneDate(readings.end).format('YYYY-MM-DD HH:mm:ss z'),
      },
    ];

    csvContent += `${details.map(r => r.label + ': ' + r.value).join(',')}\r\n\r\n`;

    const columns = {
      "timestamp": {
        name: "Timestamp",
        process: reading => {
          return window.getUserTimezoneDate(reading.sensor_time).format('YYYY-MM-DD HH:mm:ss z');
        },
      },
      "temperature": {
        name: "Temperature",
        process: reading => {
          return celsiusToUserTemp(reading.temperature, 1);
        },
      },
      "probe_temp": {
        name: "Probe Temperature",
        process: reading => {

          if(!reading.tcTemp || reading.tcTemp === 'n') {
            return 'n/a';
          }

          return celsiusToUserTemp(reading.tcTemp, 1);

        },
        requires: "probe"
      },
      "humidity": {
        name: "Humidity",
        process: reading => {
          return reading.humidity;
        },
      },
      "heat_index": {
        name: "Heat Index",
        process: reading => {

          const temp = celsiusToFahrenheit(reading.temperature);
          const humidity = reading.humidity;

          const heatIndexF = getHeatIndex(temp, humidity);

          if(window.getUserTempPref() === 'C') {
            return fahrenheitToCelsius(heatIndexF, 1);
          } else {
            return roundTo(heatIndexF, 1);
          }

        },
      },
      "dew_point": {
        name: "Dew Point",
        process: reading => {
          return getDewpoint(reading.humidity, reading.temperature, false);
        },
      },
      "battery": {
        name: "Battery",
        process: reading => {

          if(!isUndefined(reading.voltage)) {
            return getBatteryPercentage(reading.voltage);
          } else {
            return "n/a";
          }

        },
      },
      "power": {
        name: "USB Power",
        requires: "power",
        process: reading => {
          if(!isUndefined(reading.pwr)) {
            if(reading.pwr == 1) {
              return 1;
            } else {
              return 0;
            }
          } else {
            return "n/a";
          }
        },
      },
      "rssi": {
        name: "Connection Quality (RSSI)",
        process: reading => {

          if(!isUndefined(reading.rssi)) {
            return reading.rssi;
          } else {
            return "n/a";
          }

        },
      },
      "time_to_connect": {
        name: "Seconds to Connect",
        process: reading => {

          if(!isUndefined(reading.time_to_connect)) {
            return reading.time_to_connect;
          } else {
            return "n/a";
          }

        },
      }
    };

    let hasProbe = false;
    let hasPower = false;

    if(typeof sensor.last_tcTemp != 'undefined') {
      hasProbe = true;
    }

    if(typeof sensor.last_pwr != 'undefined') {
      hasPower = true;
    }

    console.log(window.currentUser);

    Object.entries(columns).forEach(entry => {

      const column = entry[1];

      // check if the datapoint is in the user's preferences
      if(
        entry[0] !== 'timestamp' &&
        window.currentUser &&
        window.currentUser.csv_datapoints &&
        !window.currentUser.csv_datapoints.includes(entry[0])
      ) {
        return;
      }

      if(column.requires && column.requires === 'power' && !hasPower) {
        return;
      } else if(column.requires && column.requires === 'probe' && !hasProbe) {
        return;
      }

      csvContent += column.name + ",";

    });

    csvContent += "\r\n";

    if(!readings || !readings.raw) {
      return;
    }

    readings.raw.forEach(reading => {

      Object.entries(columns).forEach(entry => {

        const column = entry[1];

        // check if the datapoint is in the user's preferences
        if(
          entry[0] !== 'timestamp' &&
          window.currentUser &&
          window.currentUser.csv_datapoints &&
          !window.currentUser.csv_datapoints.includes(entry[0])
        ) {
          return;
        }

        if(column.requires && column.requires === 'power' && !hasPower) {
          return;
        } else if(column.requires && column.requires === 'probe' && !hasProbe) {
          return;
        }

        csvContent += column.process(reading) + ",";

      });

      csvContent += "\r\n";

    });

    const blob = new Blob([csvContent], {type: 'text/csv'});
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';

    a.href = url;
    a.download = sensor.sensor_id + '--' + moment().format('YYYY-MM-DD') + '--' + dateRange + '.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    $(a).remove();

    resolve();
    
  });

};

export default downloadReadings;
